import React, { useMemo } from 'react';
import { Grid, GridProps, Typography } from "@mui/material";
import { formatCurrencyValue } from "../../util/PaymentUtils";

interface PayoutTransaction {
  payoutAmount: number;
}

interface TotalPayoutProps {
  payoutTransactions?: PayoutTransaction[];
  title?: string;
  gridItemProps?: GridProps;
}

/**
 * Displays the total payout amount for the given payout transactions.
 *
 * @param payoutTransactions Array of payout transactions
 * @param title Optional title suffix to display after "Total Payout Amount"
 * @param gridItemProps Optional MUI Grid props to pass to the container Grid item
 * @returns JSX.Element
 */
const TotalPayout = ({
  payoutTransactions = [],
  title = '',
  gridItemProps
}: TotalPayoutProps) => {
  const totalPayout = useMemo(() => {
    return formatCurrencyValue(
      payoutTransactions.reduce((acc, transaction) => acc + transaction.payoutAmount, 0)
    );
  }, [payoutTransactions]);

  return (
    <Grid item {...gridItemProps}>
      <Typography variant={'body1'}>
        Total Payout Amount{title && ` ${title}`}: {totalPayout}
      </Typography>
    </Grid>
  );
};

export default TotalPayout;
